export default {
    data() {
        return {
            customFields: [],
            customFieldValues: [],
            multipleValue: [
                'checkbox',
                'third',
                'people',
                'staff',
                'item',
            ],
        }
    },
    methods: {
        referenceCf(customField) {
            return `cf_${customField.type}_${customField.customFieldId}`
        },
        correspondingData(customField) {
            // if multiple or autocomplete => send all customfieldValues with the same customFieldsId
            if (this.multipleValue.indexOf(customField.type) !== -1) {
                return this.customFieldValues.filter(field => field.customFieldId == customField.id)
            } else {
                return this.customFieldValues.find(field => field.customFieldId == customField.id)
            }
        },
        updateValue(newValue) {
            this.errors.clear(this.referenceCf(newValue))
            let index = -1
            if (this.multipleValue.indexOf(newValue.type) == -1) {
                if (newValue.id != null) {
                    index = this.customFieldValues.findIndex(el => el.id == newValue.id)
                } else {
                    index = this.customFieldValues.findIndex(el => el.customFieldId == newValue.customFieldId)
                }
            } else {
                index = this.customFieldValues.findIndex(el => el.customFieldId == newValue.customFieldId && el.numericValue == newValue.numericValue)
            }
            if (index !== -1) {
                this.customFieldValues[index] = newValue;
            } else {
                this.customFieldValues.push(newValue)
            }
        },
        removeValue(newValue) {
            this.errors.clear(this.referenceCf(newValue))
            let index = this.customFieldValues.findIndex(el => el.customFieldId == newValue.customFieldId && el.numericValue == newValue.numericValue)
            if (index !== -1) {
                this.customFieldValues.splice(index, 1);
            }
        },
        errorValue(error) {
            this.errors.setOneError(error.name, error.message)
            this.$forceUpdate()
        },
        labelCf(customfield){
            return customfield.name + (customfield.isRequired ? ' *' : '')
        }
    }
}
